var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgTieredCake = function SvgTieredCake(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 18,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.031.25c.777 0 1.407.49 1.407 1.094v4.468a1 1 0 01-1 1H4.563a1 1 0 01-1-1V1.345C3.563.739 4.191.25 4.968.25H19.03zM2.156 9h19.688c.777 0 1.406.653 1.406 1.458v6.292a1 1 0 01-1 1H1.75a1 1 0 01-1-1v-6.292C.75 9.653 1.38 9 2.156 9z",
    fill: "#1F1F1F"
  })));
};

export default SvgTieredCake;